import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Home, ArrowRight, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Helmet>
        <title>Page Not Found | Snake Signals</title>
        <meta name="description" content="The page you're looking for doesn't exist. Find Python salary data, interview prep, and hiring resources on Snake Signals." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold font-orbitron text-primary mb-4">404</div>
        <h1 className="text-2xl font-bold mb-2 text-foreground">Page not found</h1>
        <p className="text-muted-foreground mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Go Home
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/python-newsletter/">
              Newsletter <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
        
        <div className="text-sm text-muted-foreground">
          <p className="mb-2">Looking for something specific?</p>
          <div className="flex flex-wrap justify-center gap-2">
            <Link to="/salary/" className="text-primary hover:underline">Salary Guide</Link>
            <span>•</span>
            <Link to="/cv-reviewer/" className="text-primary hover:underline">CV Analyzer</Link>
            <span>•</span>
            <Link to="/interview-prep/" className="text-primary hover:underline">Interview Prep</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;